export default {
  get name(): string {
    return 'ExponentSegment';
  },
};
